<template>
  <div class="communications">

    <div class="nav">常用收发通</div>
    <div class="home-page-tab">
      <el-tabs v-model="tabIndex">
        <el-tag :type="tabIndex == 0?'success':''" @click="tabIndex = '0'">国内</el-tag>
        <el-tag :type="tabIndex == 1?'success':''" @click="tabIndex = '1'">海外</el-tag>
      </el-tabs>
    </div>
    <!-- 搜索 -->
    <div class="search-box">
      <el-form :inline="true">
        <el-form-item>
          <el-input size="small" v-model.trim="searchValue" placeholder="请输入企业名称" style="width: 220px;margin-right: 10px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="button" type="primary" size="small" @click="searchData"> <span style="width:45px;display: inline-block">查询</span> </el-button>
          <el-button class="button" type="primary" size="small" @click="showDialog('add')">新增收发通</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="list">
      <div class="table-list" v-loading="loading">
        <div v-if="dataSource.length > 0">
          <div class="address-box" v-for="item in dataSource" :key="item.id">
            <el-row :gutter="18">
              <div v-if="tabIndex == '0'">
                <el-col :span="10">
                  <div class="cloumn">
                    <div class="title" style="font-size:16px">国家代码：</div>
                    <div class="text">{{item.countryCode}}</div>
                  </div>
                </el-col>
                <el-col :span="10">
                  <div class="cloumn">
                    <div class="title" style="font-size:16px">联系电话：</div>
                    <div class="text">{{item.contact}}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="ctrl">
                    <el-link :underline="false" type="primary" @click="showDialog('edit',item)"><i class="iconfont icon-bianji"></i></el-link>
                    <el-link :underline="false" type="primary" @click="deleteAddr(item)"><i class="iconfont icon-shanchu"></i></el-link>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="cloumn">
                    <div class="title">企业名称：</div>
                    <div class="text txt24">{{item.customerName}}</div>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="cloumn">
                    <div class="title">公司地址：</div>
                    <div class="text txt24">{{item.address}}</div>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="cloumn">
                    <div class="title">实际联系人：</div>
                    <div class="text txt24">{{item.actualContactPerson||'/'}}</div>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="cloumn">
                    <div class="title">联系人电话：</div>
                    <div class="text txt24">{{item.actualContactTel||'/'}}</div>
                  </div>
                </el-col>
              </div>
              <div v-if="tabIndex == '1'">
                <el-col :span="10">
                  <div class="cloumn">
                    <div class="title " style="font-size:16px">国家代码：</div>
                    <div class="text">{{item.countryCode}}</div>
                  </div>
                </el-col>
                <el-col :span="10">
                  <div class="cloumn">
                    <div class="title" style="font-size:16px">邮编：</div>
                    <div class="text">{{item.postcode}}</div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="ctrl">
                    <el-link :underline="false" type="primary" @click="showDialog('edit',item)"><i class="iconfont icon-bianji"></i></el-link>
                    <el-link :underline="false" type="primary" @click="deleteAddr(item)"><i class="iconfont icon-shanchu"></i></el-link>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="cloumn">
                    <div class="title">企业名称：</div>
                    <div class="text txt24">{{item.customerName}}</div>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="cloumn">
                    <div class="title">城市：</div>
                    <div class="text txt24">{{item.city}}</div>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="cloumn">
                    <div class="title">州/省：</div>
                    <div class="text txt24">{{item.province}}</div>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="cloumn">
                    <div class="title">公司地址：</div>
                    <div class="text txt24">{{item.address}}</div>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="cloumn">
                    <div class="title">联系人电话：</div>
                    <div class="text txt24">{{item.actualContactTel||'/'}}</div>
                  </div>
                </el-col>
              </div>
            </el-row>
          </div>
        </div>
        <div class="empty" v-else>
          <el-empty description="无收发通记录"></el-empty>
        </div>
        <div class="global-page">
          <el-pagination background @size-change="changePageSize" @current-change="changePage" :page-sizes="[15, 30, 45, 60]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :current-page="current" :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <AddDialog ref="addDialog" v-if="visible" :customerType="tabIndex" :modalTitle="modalTitle" :visible="visible" @success="success" @close="close" />
  </div>
</template>

<script>
import regionSelect from "@/components/select/RegionSelect"
import AddDialog from "./components/AddDialog"
import { httpAjax } from "@/api/ajax"
export default {
  name: "index",
  components: {
    regionSelect,
    AddDialog
  },
  data () {
    return {
      tabIndex: 0,
      loading: false,
      modalTitle: '',
      recordItem: {},
      visible: false,
      searchForm: {},
      dataSource: [],
      current: 1,
      total: 0,
      pageSize: 15,
      countryData: [],
      fetching: false,
      record: null,
      searchValue: '',
      regionArr: []
    }
  },
  watch: {
    tabIndex () {
      this.searchData()
    }
  },
  created () {
    this.getData({
      keyword: '',
      currentPage: this.current,
      pageSize: this.pageSize,
    })
  },
  mounted () { },
  methods: {

    // 国家
    getCountry (query) {
      if (!query) return
      httpAjax({
        url: `/services/base/data/country/${query}`,
        method: "get",
      }).then(res => {
        // 目的地 港口

      })
    },

    //获取地区选择组件的数据
    getRegionData (...data) {
      this.regionArr = data
    },
    // 获取数据
    getData (params) {
      this.loading = true
      setTimeout(() => {
        httpAjax({
          url: `/services/customer`,
          method: "get",
          data: {
            type: Number(this.tabIndex),
            ...params
          },
        }).then((response) => {
          if (response.success) {
            const dataSource = response.data || []
            this.dataSource = dataSource
            this.current = response.pager.currentPage
            this.total = Number(response.pager.total)
          } else {
            this.$message({
              message: response.msg,
              type: 'error'
            })
          }
          this.loading = false
        })
      }, 300)
    },

    // 输入查询内容
    changeValue (e) {
      this.searchValue = e.target.value
    },

    // 查询数据
    searchData () {
      this.getData({
        keyword: this.searchValue,
        currentPage: 1,
        pageSize: this.pageSize,
      })
    },

    // 切换页码
    changePage (page) {
      this.getData({
        keyword: this.searchValue,
        currentPage: page,
        pageSize: this.pageSize,
      })
    },

    // 切换每页数量
    changePageSize (num) {
      this.pageSize = num
      this.getData({
        keyword: this.searchValue,
        currentPage: this.current,
        pageSize: num,
      })
    },

    // 显示弹窗
    showDialog (type, item) {
      this.getCompanyApply(() => {
        this.visible = true
        if (type == 'add') {
          this.modalTitle = '新增收发通'
        } else {
          this.modalTitle = '编辑收发通'
          setTimeout(() => { this.$refs.addDialog.handEdit(JSON.parse(JSON.stringify(item))) }, 50)
        }
      })
    },

    // 获取公司认证信息
    getCompanyApply (fn) {
      httpAjax({
        url: `/services/company/currentCompany`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          if (!response.data) {
            this.$message({ message: '请先认证企业信息', type: 'warning' })
            this.$router.push({ path: 'certification' })
            return
          }
          if (response.data && response.data.status === 20) {
            this.getUserData(() => {
              fn()
            })
          } else {
            this.$message({ message: '请先认证企业信息', type: 'warning' })
            this.$router.push({ path: 'certification' })
          }
        } else {
          this.$message({
            message: response.msg,
            type: "error",
          })
        }
      })
    },
    // 获取用户信息
    getUserData (fn) {
      httpAjax({
        url: `/services/user/currentUser`,
        method: "get",
      }).then((response) => {
        if (response.success) {
          if (response.data.companyUserStatus == 1) {
            fn()
          } else {
            this.$message({ message: '请先认证企业信息', type: 'warning' })
            this.$router.push({ path: 'certification' })
          }
        }
      })
    },

    // 删除地址
    deleteAddr (item) {
      this.$confirm('确定删除此条收发通吗？', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        httpAjax({
          url: `/services/customer/${item.customerId}`,
          method: 'delete',
        }).then((response) => {
          if (response.success) {
            this.$message({
              message: '删除成功！',
              type: 'success'
            })
            this.getData({
              keyword: this.searchValue,
              currentPage: this.current,
              pageSize: this.pageSize,
            })
          } else {
            this.$message({
              message: response.msg,
              type: 'error'
            })
          }
        })
      }).catch(() => {

      })
    },
    success () {
      this.visible = false
      this.getData({
        keyword: '',
        currentPage: 1,
        pageSize: this.pageSize,
      })
    },
    close () {
      this.visible = false
    }
  },
}
</script>

<style scoped lang="less">
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
}

.communications {
  padding: 24px;
  background-color: white;
  box-sizing: border-box;
  height: 100%;
  .nav {
    font-size: 24px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
  }
  .table-list {
    overflow: hidden;
    ::v-deep .el-col {
      margin-bottom: 10px;
      .title {
        font-size: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333 !important;
      }
      .text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
      }
    }
  }

  .search-box {
    height: 56px;
    background: white;
    margin: 14px 0 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border-radius: 4px;

    .el-form-item {
      margin-bottom: 0;
    }
  }

  .button {
    height: 32px;
  }
  .list {
    .pagination {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 8px 0 16px 16px;
    }

    .address-box {
      width: 48%;
      height: 280px;
      display: inline-block;
      padding: 24px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      cursor: pointer;
      transition: 0.3s;
      margin: 0 16px 16px 0;

      // &:hover {
      //   border-color: #ecf1ff;
      //   .ctrl {
      //     opacity: 1;
      //   }
      // }

      .ctrl {
        width: 80px;
        margin-right: 16px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        a {
          font-weight: 400;
          margin-left: 10px;
        }
      }
      .mb {
        margin-bottom: 22px;
      }

      .cloumn {
        display: flex;
        flex-direction: row;
        font-size: 13px;
        min-height: 24px;

        .title {
          width: 106px;
          color: #989898;
          text-align: right;
          font-size: 14px;
          margin-right: 8px;
        }

        .text {
          flex: 1;
          word-break: break-word;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;

          &.txt24 {
            padding-right: 24px;
          }
        }
      }
    }
  }

  .addr-form {
    .el-form-item__label {
      height: 40px;
      line-height: 40px;
      padding-right: 10px;
    }
    .el-select .el-input__inner {
      height: 40px;
      line-height: 40px;
    }
  }
}

::v-deep .el-tag {
  border: none;
  background-color: white;
  width: 88px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  margin-right: 24px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  cursor: pointer;
}
::v-deep .el-tag--success {
  background-color: #eff5ff;
  color: #1170eb;
}
</style>